import { createRecipeFunction } from 'services/firebase';

import RecipeMapper from 'services/mappers/recipes/RecipeMapper';

const create = async (recipeDataModel) => {
  if (!recipeDataModel)
    throw new Error('create: recipeDataModel cannot be empty');

  if (!recipeDataModel.hash)
    throw new Error('create: recipeDataModel.hash cannot be empty');

  const res = await createRecipeFunction({ recipe: recipeDataModel });

  const { id, documentData } = res.data;

  return RecipeMapper.mapFirebaseRefToModel(id, documentData);
};

export default create;
